import { createApp } from 'vue'
import App from './App.vue' 
import router from './router'
import store from './store'
import {  importFnComponents  } from './components'
import { models, initMouleServe } from './servece'
import { registerMicroApps, start , initGlobalState} from "qiankun";
import zhCn from 'element-plus/es/locale/lang/zh-cn' //中文库 
import {ElConfigProvider} from "element-plus"
import ElementPlus from "element-plus"
import 'element-plus/dist/index.css'
import microApp from './utils/micro-app'
import {useRouter} from 'vue-router'
// import "lib-flexible-computer";
import '@/utils/flexible-computer'
import '@/utils/rem'
import '@/styles/common.less';

// 子应用切换加载进度条 
import "nprogress/nprogress.css"; 
const config = {
  // 挂载前回调
  beforeLoad: [
    (app) => {
     // NProgress.start();
      console.log("beforeload", app);
    },
  ],
  afterMount: [
    (app) => {
       // 加载微应用前，进度条加载完成    
       console.log("afterMount", app);
     //  NProgress.done();
    }
  ],
  // 挂载后回调
  beforeMount: [
    (app) => {
      console.log("beforeMount", app);
    },
  ],
  // 卸载后回调
  afterUnmount: [
    (app) => {
      console.log("afterMount", app);
    },
  ],
};

const app = createApp({
   //...App, 
     setup() {
      // 微应用通信 定义全局状态，并返回通信方法
     /* const state = {}
      const actions = initGlobalState(state);
      actions.setGlobalState({
          globalToken: ''
      }) */
     
        registerMicroApps(microApp(
          {
          routerBase: useRouter()
          }
        ), config)
      },
     render() {
        return <ElConfigProvider locale={zhCn}> 
                <App />
             </ElConfigProvider>
        }
       }) 
        app.use(store)
        app.use(router)
        app.use(ElementPlus)
        app.mount('#app')
        importFnComponents(app)
        initMouleServe(app, models)
      
     
        
     